import {combineReducers} from 'redux';
import * as actions from './actions';

const activeTab = (prevActiveTab = 'COURSE', action) => {
    switch (action.type) {
        case actions.ACTION_ACTIVATE_PLAYERS_TAB:
            return 'PLAYERS';
        case actions.ACTION_ACTIVATE_COURSE_TAB:
            return 'COURSE';
        default:
            return prevActiveTab;
    }
};

const courses = (prevCourses = [], action) => {
    switch (action.type) {
        case actions.ACTION_RECEIVE_COURSES:
            return action.courses;
        default:
            return prevCourses;
    }
};

const players = (prevPlayers = [], action) => {
    switch (action.type) {
        case actions.ACTION_RECEIVE_PLAYERS:
            return action.players;
        case actions.ACTION_SELECT_PLAYER: {
            /*
             If we add a player from the search results, then that player object is not in state.players,
             therefore we have to manually add it here.
             */
            const playerExists = prevPlayers.filter(p => p.id === action.player.id);
            if (playerExists.length === 0) {
                return [...prevPlayers, {...action.player, selected: true}];
            } else {
                return prevPlayers.map((player) => {
                    if (player.id === action.player.id) {
                        return {...player, selected: !player.selected};
                    }
                    return player;
                });
            }
        }
        // ACTION_ADD_PLAYER is used when the user creates a new user, and then the new user is returned from the
        // server. But since the "new user" might have already existed in the database and it could have been
        // also already selected for the game, then we can't use ACTION_SELECT_PLAYER, because that would just
        // toggle it.
        case actions.ACTION_ADD_PLAYER: {
            const playerExists = prevPlayers.filter(p => p.id === action.player.id);
            if (playerExists.length === 0) {
                return [...prevPlayers, {...action.player, selected: true}];
            } else {
                return prevPlayers.map((player) => {
                    if (player.id === action.player.id) {
                        return {...player, selected: true};
                    }
                    return player;
                });
            }
        }
        default:
            return prevPlayers;
    }
};

const searchBarIsOpen = (isActive = false, action) => {
    switch (action.type) {
        case actions.ACTION_OPEN_SEARCHBAR:
            return true;
        case actions.ACTION_CLEAR_SEARCH:
            return false;
        default:
            return isActive;
    }
};

const searchResultsCourses = (prevCourses = [], action) => {
    switch (action.type) {
        case actions.ACTION_RECEIVE_COURSES_FROM_SEARCH:
            return action.courses;
        case actions.ACTION_CLEAR_SEARCH:
            return [];
        default:
            return prevCourses;
    }
};

const searchResultsPlayers = (prevPlayers = [], action) => {
    switch (action.type) {
        case actions.ACTION_RECEIVE_PLAYERS_FROM_SEARCH:
            return action.players;
        case actions.ACTION_CLEAR_SEARCH:
            return [];
        default:
            return prevPlayers;
    }
};

const searchQuery = (query = '', action) => {
    switch (action.type) {
        case actions.ACTION_ACTIVATE_SEARCH:
            return action.query;
        case actions.ACTION_CLEAR_SEARCH:
            return '';
        default:
            return query;
    }
};
const searchType = (type = '', action) => {
    switch (action.type) {
        case actions.ACTION_ACTIVATE_SEARCH:
            return action.queryType;
        case actions.ACTION_CLEAR_SEARCH:
            return '';
        default:
            return type;
    }
};

const search = combineReducers({
    isOpen: searchBarIsOpen,
    courses: searchResultsCourses,
    players: searchResultsPlayers,
    query: searchQuery,
    type: searchType,
});


const disableStartingGame = (isDisabled = false, action) => {
    switch (action.type) {
        case actions.ACTION_DISABLE_START_GAME_BUTTON:
            return true;
        default:
            return isDisabled;
    }
};

const activeCourse = (course = null, action) => {
    switch (action.type) {
        case actions.ACTION_SELECT_COURSE:
            return action.courseId;
        default:
            return course;
    }
};

// Used in the form that is posted in order to create the game
const activePlayers = (prevPlayers = [], action) => {
    switch (action.type) {
        case actions.ACTION_SELECT_PLAYER: {
            const id = action.player.id;
            const index = prevPlayers.indexOf(id);

            if (index > -1) {
                return [
                    ...prevPlayers.slice(0, index),
                    ...prevPlayers.slice(index + 1),
                ];
            }
            return [...prevPlayers, id];
        }

        // ACTION_ADD_PLAYER is used when the user creates a new user, and then the new user is returned from the
        // server. But since the "new user" might have already existed in the database and it could have been
        // also already selected for the game, then we can't use ACTION_SELECT_PLAYER, because that would just
        // toggle it.
        case actions.ACTION_ADD_PLAYER: {
            if (prevPlayers.indexOf(action.player.id) === -1) {
                return [...prevPlayers, action.player.id];
            }
            return prevPlayers;
        }
        default:
            return prevPlayers;
    }
};

const loadingIndicator = (isVisible = true, action) => {
    switch (action.type) {
        case actions.ACTION_SHOW_LOADING_INDICATOR:
            return true;
        case actions.ACTION_HIDE_LOADING_INDICATOR:
            return false;
        default:
            return isVisible;
    }
};

const createNewUserFormShowForm = (showForm = false, action) => {
    switch (action.type) {
        case actions.ACTION_CREATE_NEW_USER_FORM_SHOW_FORM:
            return true;
        case actions.ACTION_CREATE_NEW_USER_FORM_HIDE_FORM:
            return false;
        default:
            return showForm;
    }
};

const createNewUserFormErrors = (error = '', action) => {
    switch (action.type) {
        case actions.ACTION_CREATE_NEW_USER_FORM_SHOW_ERRORS:
            return action.error;
        case actions.ACTION_CREATE_NEW_USER_FORM_HIDE_ERRORS:
            return '';
        default:
            return error;
    }
};

const createNewUserForm = combineReducers({
    showForm: createNewUserFormShowForm,
    error: createNewUserFormErrors,
});

const form = combineReducers({
    activeCourse,
    activePlayers,
});

const createGameReducer = combineReducers({
    players,
    courses,
    form,
    activeTab,
    disableStartingGame,
    search,
    loadingIndicator,
    createNewUserForm,
});

export default createGameReducer;



// WEBPACK FOOTER //
// ./src/apps/create_game/reducers.js